import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const navItems = [
  { num: '01', name: 'Stack', hash: '#stack' },
  { num: '02', name: 'Work', hash: '#work' },
  { num: '03', name: 'Career', hash: '#career' },
  { num: '04', name: 'About', hash: '#about' },
];

const Navbar = () => {
  const { pathname } = useLocation();
  // Section links only exist on the home page; elsewhere jump back to them.
  const base = pathname === '/' ? '' : '/';

  return (
    <header id="top" className="topbar">
      <div className="topbar-inner wrap">
        <Link to="/" className="brand" aria-label="Benjo M. Abrasado, home">
          <span className="brand-mark">BMA</span>
          <span className="brand-domain mono">benjomabrasado.space</span>
        </Link>

        <nav aria-label="Primary" className="topnav mono">
          {navItems.map((item) => (
            <a key={item.hash} href={`${base}${item.hash}`} className="topnav-link">
              <span className="topnav-num">[{item.num}]</span> {item.name}
            </a>
          ))}
          <a href={`${base}#contact`} className="topnav-link topnav-cta">
            [05] Contact →
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
